import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/Topbar.css"; // Assuming you have a CSS file for styling

const Topbar = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/documents");
  };

  return (
    <div className="topbar">
      <div
        className="header-icon"
        onClick={handleBackClick}
        style={{ cursor: "pointer" }}
      >
        <div className="icon-back">
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M 12.6668 8.7749 H 3.3335 M 3.3335 8.7749 L 8.00016 13.4416 M 3.3335 8.7749 L 8.00016 4.10823" />
            </svg>
          </div>
          <div className="icon-text">Back</div>
        </div>
      </div>
      <div className="document-properties">
        <div className="title">
          <div className="header">Document properties</div>
          <div className="subheader">
            <div className="markup-mode">Open Markup Mode</div>
            <div className="supersede">Supersede Documents</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
